import { HomeBannerProps } from "./HomeBanner";
import { Box, Grid, Paper, Typography, Skeleton, Stack } from "@mui/material";
import Container from "@mui/material/Container";
import { ButtonCust } from "../../widgets/Button/ButtonCust";
import Styles from "./S5_HomeBanner.module.scss";
import config from "../../../config/env.config.json";
import clsx from "clsx";
import { getResolutionDetails } from "../../../utils/commonFunctions/ReusableFunctions";
import { generateImageContainer } from "../../../utils/commonFunctions/generateImageTemplate";
import { CustomerStatus as CS } from "../../../enums/CustomerStatus";
import { BrandNameUpdate } from "../../../utils/commonFunctions/BrandNameUpdate";

const HomeBannerT5 = (props: HomeBannerProps) => {
  const {
    heading,
    sub_heading,
    button_text,
    banner_web,
    banner_mobile,
    banner_ipad,
    button_text2,
    list_items,
    heading2,
    banner_web_hero,
    banner_ipad_hero,
    banner_mobile_hero,
    banner_web_bg,
    banner_ipad_pro,
    banner_mobile_bg,
    res,
  } = props?.bannerContent || {};
  const { largeDesktop, desktop, ipad, mobile } = getResolutionDetails();
  const { pageName } = props;
  const { content_carousel, ticks_main_div, list_item_txt, button2 } = Styles;
  let customerDetails: any = localStorage?.getItem("customerDetail");
  customerDetails = JSON.parse(customerDetails);
  const { status } = customerDetails || {};
  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        position: "relative",
        minHeight: { xs: "600px", sm: "300px", md: "300px", lg: "500px" },
        backgroundImage: `url(${
          mobile
            ? banner_mobile_bg?.data?.attributes?.url
            : banner_web_bg?.data?.attributes?.url
        }) !important`,
        backgroundRepeat: "no-repeat",
      }}
    >
      {banner_web || banner_ipad || banner_mobile ? (
        <>
          <Grid
            sx={{
              position: "absolute",
              height: { xs: "100%", sm: "auto" },
              textAlign: {
                xs: "var(--main_banner_title_f_align_mobile)",
              },
            }}
            className={content_carousel}
          >
            <Grid
              item
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: { xs: "column", sm: "row" },
                width: { xs: "100%", sm: "90%" },
                height: { xs: "100%", sm: "auto" },
              }}
            >
              <Box
                sx={{
                  textAlign: "center",
                  paddingLeft: { xs: "0%", sm: "5%" },
                  paddingTop: { xs: "31px", sm: "0px" },
                }}
              >
                {heading && (
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "26px !important",
                        sm: "45px !important",
                      },
                      textAlign: {
                        xs: res?.headingAlignment_xs
                          ? res?.headingAlignment_xs
                          : "center",
                        lg: res?.headingAlignment_lg
                          ? res?.headingAlignment_lg
                          : "center",
                      },
                    }}
                    component="h1"
                    variant="h3"
                    gutterBottom
                    className="main_banner_title"
                    dangerouslySetInnerHTML={{
                      __html: BrandNameUpdate(heading),
                    }}
                  />
                )}
                {heading2 && (
                  <Typography
                    component="h3"
                    variant="h3"
                    gutterBottom
                    className="main_banner_title"
                  >
                    {BrandNameUpdate(heading)}
                  </Typography>
                )}
                {sub_heading && (
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "18px !important",
                        sm: "20px !important",
                      },
                      fontWeight: "var(--font_weight_1) !important",
                      textAlign: {
                        xs: res?.headingAlignment_xs
                          ? res?.headingAlignment_xs
                          : "center",
                        lg: res?.headingAlignment_lg
                          ? res?.headingAlignment_lg
                          : "center",
                      },
                      color: res?.subHeadingColor ? res?.subHeadingColor : "",
                    }}
                    variant="h4"
                    component="h4"
                    className={clsx(ticks_main_div, "main_banner_sub_title")}
                  >
                    {BrandNameUpdate(sub_heading)}
                  </Typography>
                )}
                {list_items?.length > 0 ? (
                  <Box
                    width={"100%"}
                    pb={{
                      xs: "15px",
                      md: "25px",
                    }}
                    sx={{ ml: { xs: "45px", md: "unset" } }}
                  >
                    {list_items.map((item: any, index: any) => {
                      return (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            p: "10px 0px 0px",
                          }}
                        >
                          {item?.image?.data?.attributes?.url ? (
                            <Box
                              component={"img"}
                              alt={BrandNameUpdate(
                                item?.image?.data?.attributes?.alternativeText
                              )}
                              src={item?.image?.data?.attributes?.url}
                              sx={{ width: "16px" }}
                            />
                          ) : null}
                          <Box className={list_item_txt}>{item?.offer}</Box>
                        </Box>
                      );
                    })}
                  </Box>
                ) : null}
                {button_text && (
                  <ButtonCust
                    variantType={config.PRIMARY_BUTTON_TYPE}
                    onClick={props.onButton1Click}
                    sx={{
                      position: "relative",
                      display: "flex",
                      margin: { xs: "auto", md: "unset" },
                    }}
                    disabled={
                      pageName === "PostActivationHome" &&
                      status !== CS.ACTIVE &&
                      status !== CS.SUSPENDED
                        ? true
                        : false
                    }
                  >
                    {button_text}
                  </ButtonCust>
                )}
                {button_text2 && (
                  <Box
                    className={button2}
                    sx={{
                      display: "flex",
                      cursor: "pointer",
                      justifyContent: { xs: "center", sm: "start" },
                      width: { sm: "max-content" },
                      position: { sm: "absolute" },
                      left: { sm: "6%" },
                    }}
                  >
                    <Box
                      component="span"
                      sx={{ fontFamily: "inherit" }}
                      onClick={() => props.onButton2Click()}
                    >
                      {button_text2}
                    </Box>
                  </Box>
                )}
              </Box>
              <Box
                sx={{
                  backgroundImage: `url(${
                    mobile
                      ? banner_mobile?.data?.attributes?.url
                      : banner_web?.data?.attributes?.url
                  }) !important`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  maxWidth: { xs: "310px", sm: "100%" },
                }}
              >
                {(largeDesktop || desktop) &&
                  generateImageContainer({
                    data: banner_web_hero,
                    attrs: {
                      width: "100%",
                      height: "100%",
                    },
                  })}
                {ipad &&
                  generateImageContainer({
                    data: banner_ipad_hero,
                    attrs: {
                      width: "100%",
                      height: "100%",
                    },
                  })}
                {mobile &&
                  generateImageContainer({
                    data: banner_mobile_hero,
                    attrs: {
                      width: "100%",
                      height: "100%",
                    },
                  })}
              </Box>
            </Grid>
          </Grid>
        </>
      ) : (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            minHeight: { xs: "500px", sm: "300px", md: "300px", lg: "500px" },
          }}
        >
          <Stack spacing={1} width="70%">
            <Skeleton
              animation="wave"
              variant="rounded"
              width={"100%"}
              height={50}
            />
            <Skeleton
              animation="wave"
              variant="rounded"
              width={"100%"}
              height={50}
            />
            <Skeleton
              animation="wave"
              variant="rounded"
              width={"100%"}
              height={50}
            />
            <Skeleton
              animation="wave"
              variant="rounded"
              width={"100%"}
              height={50}
            />
            <Skeleton
              animation="wave"
              variant="rounded"
              width={"100%"}
              height={50}
            />
          </Stack>
        </Box>
      )}
    </Container>
  );
};

export default HomeBannerT5;
